import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportMigration extends GuiListGeneric {
    constructor() {
        super("Migration");
    }
}
